module.exports = __webpack_public_path__ + "img/edge-security-acceleration.38c6869.svg";